const runtimeConfig = window.__APP_CONFIG__ || {}

export const getEnv = (name) => {
  const runtimeValue = runtimeConfig[name]
  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
    return runtimeValue
  }

  const buildTimeValue = process.env[name]
  return buildTimeValue || ''
}
